import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

function Card({ s, big, index }) {
  return (
    <motion.button
      data-testid={`service-card-${s.key}`}
      onClick={() => {
        window.dispatchEvent(new CustomEvent("oka:preselect-service", { detail: s.title }));
        document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
      }}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden text-left border border-[#0B132B]/10 ${big ? "md:col-span-2 min-h-[420px]" : "min-h-[340px]"}`}
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={s.image}
          alt={s.title}
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B] via-[#0B132B]/40 to-transparent" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-between p-7 md:p-9">
        <div className="flex items-center justify-between">
          <span className="text-[11px] tracking-[0.3em] uppercase text-white/80 bg-white/10 backdrop-blur-md px-3 py-1.5 border border-white/15">
            {s.label}
          </span>
          <span className="w-11 h-11 flex items-center justify-center bg-white text-[#0B132B] translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
            <ArrowUpRight className="w-5 h-5" />
          </span>
        </div>
        <div>
          <h3 className={`font-display text-white leading-tight ${big ? "text-3xl md:text-4xl" : "text-2xl md:text-3xl"}`}>{s.title}</h3>
          <p className="text-white/70 mt-3 max-w-md text-sm md:text-base leading-relaxed">{s.desc}</p>
        </div>
      </div>
    </motion.button>
  );
}

export default function Services() {
  return (
    <section id="services" data-testid="services" className="bg-[#F8F9FA] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="text-xs tracking-[0.35em] uppercase text-[#1C2541]/50">Prestations</span>
            <h2 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight mt-5 text-[#0B132B]">
              Un service pour <span className="italic text-[#3a4a72]">chaque occasion</span>
            </h2>
          </div>
          <p className="text-[#1C2541]/60 max-w-sm">Cliquez sur une prestation pour lancer votre demande de réservation.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <Card s={SERVICES[1]} big index={0} />
          <Card s={SERVICES[0]} index={1} />
          <Card s={SERVICES[2]} index={2} />
          <Card s={SERVICES[3]} index={3} />
          <Card s={SERVICES[4]} index={4} />
        </div>
      </div>
    </section>
  );
}
